export function orderHasHsaInvoiceItems(order) {
  return Boolean(
    order?.orderItems?.some((orderItem) => orderItem?.product?.medicalCode),
  );
}

// Surfaces the backend's own message when a document-generating mutation comes
// back unsuccessful. These mutations answer with { success, url, errorMessages }
// rather than raising, so without this the UI has no way to tell a failure apart
// from a success that produced no file.
export function actionErrorMessage(response, fallback) {
  return response?.errorMessages?.[0]?.message || fallback;
}

export function hsaInvoiceErrorMessage(response) {
  return actionErrorMessage(
    response,
    'Unable to generate HSA/FSA invoice at this time',
  );
}

export function downloadPresignedUrl(url) {
  if (!url) {
    return;
  }

  let parsedUrl;

  try {
    parsedUrl = new URL(url, window.location.origin);
  } catch {
    return;
  }

  if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
    return;
  }

  const link = document.createElement('a');
  link.href = parsedUrl.href;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
}
